// extracted by mini-css-extract-plugin
export default {"indicator":"LoadingIndicator_indicator__PBqLM","number":"LoadingIndicator_number__fTCn-"};